import { Badge, Flex, Icon } from '@chakra-ui/react';
import { ClockIcon } from '@heroicons/react/24/outline';
import { formatTime12h } from '@/pages/planner/draft';

interface PlanMetaChipsProps {
  // Curriculum plans (slots) have no start_time in the wire contract — omit
  // to render without the clock chip (curSlotView's usage).
  startTime?: string;
  durationMinutes: number;
}

// Shared meta-chip row for the view screen: start time and duration.
// Extracted so the day-plan view and curriculum-slot view (curSlotView)
// both use the same chip set without duplicating markup.
export default function PlanMetaChips({ startTime, durationMinutes }: PlanMetaChipsProps) {
  return (
    <Flex gap={2} flexWrap='wrap'>
      {startTime && (
        <Badge variant='surface' size='sm'>
          <Icon as={ClockIcon} w={3} h={3} />
          {formatTime12h(startTime)}
        </Badge>
      )}
      <Badge variant='surface' size='sm'>
        {durationMinutes} min
      </Badge>
    </Flex>
  );
}
